import React from "react";
import Rating from "react-rating";
import PropTypes from "prop-types";
import { ContainerRatings, IconStar, NumbReviews } from "./style";

export default function Ratings({ reviews }) {
    const ShowRatings = () => {
        if (reviews === null || reviews === undefined) {
            return (
                <Rating
                    emptySymbol={
                        <IconStar src="/svg/starEmpty.svg" alt="star-empty" />
                    }
                    fullSymbol={
                        <IconStar src="/svg/starFull.svg" alt="star-full" />
                    }
                    readonly
                    initialRating={0}
                />
            );
        }
        if ((reviews >= 1) & (reviews <= 2)) {
            return (
                <Rating
                    emptySymbol={
                        <IconStar src="/svg/starEmpty.svg" alt="star-empty" />
                    }
                    fullSymbol={
                        <IconStar src="/svg/starFull.svg" alt="star-full" />
                    }
                    readonly
                    initialRating={1.5}
                />
            );
        } else if ((reviews > 2) & (reviews < 4)) {
            return (
                <Rating
                    emptySymbol={
                        <IconStar src="/svg/starEmpty.svg" alt="star-empty" />
                    }
                    fullSymbol={
                        <IconStar src="/svg/starFull.svg" alt="star-full" />
                    }
                    readonly
                    initialRating={3.5}
                />
            );
        } else if ((reviews >= 4) & (reviews <= 5)) {
            return (
                <Rating
                    emptySymbol={
                        <IconStar src="/svg/starEmpty.svg" alt="star-empty" />
                    }
                    fullSymbol={
                        <IconStar src="/svg/starFull.svg" alt="star-full" />
                    }
                    readonly
                    initialRating={4.5}
                />
            );
        } else if (reviews === 0) {
            return (
                <Rating
                    emptySymbol={
                        <IconStar src="/svg/starEmpty.svg" alt="star-empty" />
                    }
                    fullSymbol={
                        <IconStar src="/svg/starFull.svg" alt="star-full" />
                    }
                    readonly
                    initialRating={0}
                />
            );
        }
    };

    return (
        <ContainerRatings>
            <ShowRatings></ShowRatings>
            <NumbReviews>({reviews})</NumbReviews>
        </ContainerRatings>
    );
}

Ratings.propTypes = {
    reviews: PropTypes.number
};
